module.exports = __webpack_public_path__ + "img/1542574792.bab75965.jpg";